var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Tipos Deduccion","company":_vm.comdes,"addMethod":"itemsTipoDeduccion","closeBaseWindow":"addTipoDeduccion","titleAddMethod":"Agregar Tipos Deduccion","itemStoreName":"itemsTipoDeduccion","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Tipos Deduccion',
    edicion: 'Editar Tipos Deduccion',
    url: `/transjuma/TipoDeduccion/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }